import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/alimento`;
export const createAlimento = async (alimento) => {
  return await axios.post(`${httpUrl}/create`, alimento).then((response) => response);
};

export const getListaAlimentos = async (filtros) => {
  return await axios.post(`${httpUrl}/listByFiltros`, filtros).then((response) => response);
};

export const getAlimentoById = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const deleteAlimentoById = async (id) => {
  return await axios.delete(`${httpUrl}/${id}`).then((response) => response);
};
